import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SETTINGS} from '../config/common.settings';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ItineraryTemplatesService {
  pagedItineraryTemplates: any = [];
  onPagedItineraryTemplatesChange: Subject<any> = new BehaviorSubject({});
  itineraryTemplate: any;
  onItineraryTemplateChange: Subject<any> = new BehaviorSubject({});
  getOverviewImages: any;

  constructor(private http: HttpClient) {
  }

  getPagedItineraries(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itinerary-template/get-paged`, payload)
        .subscribe({
          next: (response: any) => {
            this.pagedItineraryTemplates = response[0];
            this.onPagedItineraryTemplatesChange.next(this.pagedItineraryTemplates);
            resolve(this.pagedItineraryTemplates);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  createItinerary(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itinerary-template/create`, payload)
        .subscribe({
          next: (response: any) => {
            this.itineraryTemplate = response;
            this.onItineraryTemplateChange.next(this.itineraryTemplate);
            this.recentlyItineraryTemplateCurrencyAndLanguageSet(this.itineraryTemplate);
            resolve(this.itineraryTemplate);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }
  createTemplateFromItinerary(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itinerary-template/create-from-itinerary`, payload)
        .subscribe({
          next: (response: any) => {
            this.itineraryTemplate = response;
            this.onItineraryTemplateChange.next(this.itineraryTemplate);
            this.recentlyItineraryTemplateCurrencyAndLanguageSet(this.itineraryTemplate);
            resolve(this.itineraryTemplate);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getItineraryById(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itinerary-template/get-one`, payload)
        .subscribe({
          next: (response: any) => {
            this.itineraryTemplate = response[0];
            this.onItineraryTemplateChange.next(this.itineraryTemplate);
            resolve(this.itineraryTemplate);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getClientPreviewItineraryById(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(
          `${SETTINGS.BASE_API}/itinerary-template/get-one/client-preview`,
          payload
        )
        .subscribe({
          next: (response: any) => {
            this.itineraryTemplate = response[0];
            this.onItineraryTemplateChange.next(this.itineraryTemplate);
            resolve(this.itineraryTemplate);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateItinerary(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/itinerary-template/update`, payload)
        .subscribe({
          next: (response: any) => {
            this.itineraryTemplate = response;
            this.onItineraryTemplateChange.next(this.itineraryTemplate);
            resolve(this.itineraryTemplate);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  deleteItinerary(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${SETTINGS.BASE_API}/itinerary-template/delete/${id}`)
        .subscribe({
          next: (response: any) => {
            this.itineraryTemplate = response;
            this.onItineraryTemplateChange.next(this.itineraryTemplate);
            resolve(this.itineraryTemplate);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  removeItineraryLockState(id: string, sessionId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .delete(`${SETTINGS.BASE_API}/itinerary-template/delete/lock/${id}`, { body: { sessionId } })
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  getItineraryByIdLockState(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itinerary-template/get-one/lock`, payload)
        .subscribe({
          next: (response: any) => {
            this.itineraryTemplate = response[0];
            this.onItineraryTemplateChange.next(this.itineraryTemplate);
            resolve(this.itineraryTemplate);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  extendLockState(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${SETTINGS.BASE_API}/itinerary-template/extend/lock`, payload)
        .subscribe({
          next: (response: any) => {
            resolve(response);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  updateItineraryLockState(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .put(`${SETTINGS.BASE_API}/itinerary-template/update/lock`, payload)
        .subscribe({
          next: (response: any) => {
            this.itineraryTemplate = response;
            this.onItineraryTemplateChange.next(this.itineraryTemplate);
            resolve(this.itineraryTemplate);
          },
          error: (error: any) => {
            if(error?.error?.code === 'ITINERARY_STATUS_ERROR' ){
              window.location.reload();
            }
            reject(error);
          },
        });
    });
  }

  getOverviewImagesItinerary(id: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${SETTINGS.BASE_API}/itinerary-template/get-overview-images/${id}`)
        .subscribe({
          next: (response: any) => {
            this.getOverviewImages = response[0]?.all_images || [];
            resolve(this.getOverviewImages);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  private recentlyItineraryTemplateCurrencyAndLanguageSet(
    data: any
  ): void {
    localStorage.setItem(
      SETTINGS.RECENTLY_ITINERARY.CURRENCY,
      data.tour.currency
    );
    localStorage.setItem(
      SETTINGS.RECENTLY_ITINERARY.LANGUAGE,
      data.tour.language
    );
    localStorage.setItem(
      SETTINGS.RECENTLY_ITINERARY.AGENT,
      data?.tour?.agent
    );
    localStorage.setItem(
      SETTINGS.RECENTLY_ITINERARY.TYPE,
      data?.tour?.type
    );
    localStorage.setItem(
      SETTINGS.RECENTLY_ITINERARY.CUSTOMER,
      data?.tour?.customer
    );
  }

  recentlyItineraryCurrencyAndLanguageGet(): any {
    const currency = localStorage.getItem(
      SETTINGS.RECENTLY_ITINERARY.CURRENCY
    );
    const language = localStorage.getItem(
      SETTINGS.RECENTLY_ITINERARY.LANGUAGE
    );
    const agent = localStorage.getItem(
      SETTINGS.RECENTLY_ITINERARY.AGENT
    );
    const type = localStorage.getItem(
      SETTINGS.RECENTLY_ITINERARY.TYPE
    );
    const customer = localStorage.getItem(
      SETTINGS.RECENTLY_ITINERARY.CUSTOMER,
    );
    return {currency, language, agent, type, customer};
  }
}
